import TopTabNavigationShifts from "../navigation/TopTabNavigationShifts";
const Shifts = ({ navigation }) => {
  return (
    <TopTabNavigationShifts drawer='Shifts' />
  );
};

export default Shifts;